module.exports = "/assets/1eadd8c18d6d6fb04d86e896f6741387.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/WX.png
// module id = 3095
// module chunks = 0